import { lazy } from "react";
import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";

import LoginRoutes from "./LoginRoutes";

import AuthenticationRoutes from "./AuthenticationRoutes";
import Loadable from "ui-component/Loadable";

// import MinimalLayout from 'layout/MinimalLayout';
const FirstLoadLogin = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Login3"))
);
const Error = Loadable(lazy(() => import("views/pages/maintenance/Error")));
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const userRole = localStorage.getItem("role");

  return useRoutes([
    { path: "/", element: <FirstLoadLogin /> },
    { path: "*", element: <Error /> },
    LoginRoutes,
    MainRoutes,
  ]);
}
// userRole === "user"
// ? PropertOwnerRoutes
// : userRole === "staff"
// ? StaffRoutes
// :
